export enum Tabs {
  upcoming = 'upcoming',
  recent = 'recent'
}
